var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 22.1667L25.5 18M25.5 18L21.3333 13.8333M25.5 18H15.5M15.5 10.5H14.5C13.0999 10.5 12.3998 10.5 11.865 10.7725C11.3946 11.0122 11.0122 11.3946 10.7725 11.865C10.5 12.3998 10.5 13.0999 10.5 14.5V21.5C10.5 22.9001 10.5 23.6002 10.7725 24.135C11.0122 24.6054 11.3946 24.9878 11.865 25.2275C12.3998 25.5 13.0999 25.5 14.5 25.5H15.5",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutWhite);
export default __webpack_public_path__ + "static/media/logout-white.e576baff3bef1212e4b60c3992d27c3e.svg";
export { ForwardRef as ReactComponent };